import { gql } from '@apollo/client';
import { CORE_EXPERT_FIELDS } from './fragments';

export const createExpert = gql`
  ${CORE_EXPERT_FIELDS}
  mutation createExpert($input: CreateExpertInput!) {
    createExpert(input: $input) {
      ...CoreExpertFields
    }
  }
`;

export const updateExpert = gql`
  ${CORE_EXPERT_FIELDS}
  mutation updateExpert($input: UpdateExpertInput!) {
    updateExpert(input: $input) {
      ...CoreExpertFields
    }
  }
`;

export const deleteExpert = gql`
  mutation deleteExpert($id: ID!) {
    deleteExpert(id: $id) {
      id
    }
  }
`;
